interface SupabaseSignupUserLike {
  identities?: unknown[] | null;
}

interface SupabaseSignupPayloadLike {
  user?: SupabaseSignupUserLike | null;
  session?: unknown | null;
}

export const STRONG_PASSWORD_MIN_LENGTH = 10;

export function normalizeAuthEmail(email: string) {
  return email.trim().toLowerCase();
}

function normalizeOrigin(origin: string) {
  return origin.replace(/\/+$/, "");
}

export function getAuthEmailRedirectTo(origin: string) {
  return `${normalizeOrigin(origin)}/auth?confirmed=1`;
}

export function getPasswordResetRedirectTo(origin: string) {
  return `${normalizeOrigin(origin)}/reset-password`;
}

export function isLikelyDuplicateSignup(payload: SupabaseSignupPayloadLike | null | undefined) {
  const identities = payload?.user?.identities;
  return Array.isArray(identities) && identities.length === 0;
}

export function isDuplicateSignupError(error: unknown) {
  const message = error instanceof Error ? error.message : String(error ?? "");
  const normalized = message.toLowerCase();

  return (
    normalized.includes("already registered") ||
    normalized.includes("already exists") ||
    normalized.includes("user already")
  );
}

export function isAuthRateLimitError(error: unknown) {
  if (!error) return false;

  const maybeStatus = (error as { status?: unknown }).status;
  const message = error instanceof Error ? error.message : String(error);
  const normalized = message.toLowerCase();

  return (
    maybeStatus === 429 ||
    normalized.includes("too many requests") ||
    normalized.includes("rate limit") ||
    normalized.includes("over email send rate limit")
  );
}

export function validateSignupPassword(password: string) {
  const failures: string[] = [];

  if (password.length < STRONG_PASSWORD_MIN_LENGTH) {
    failures.push(`use pelo menos ${STRONG_PASSWORD_MIN_LENGTH} caracteres`);
  }
  if (!/[a-z]/.test(password)) failures.push("inclua uma letra minúscula");
  if (!/[A-Z]/.test(password)) failures.push("inclua uma letra maiúscula");
  if (!/[0-9]/.test(password)) failures.push("inclua um número");
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(password)) failures.push("inclua um símbolo");

  return {
    valid: failures.length === 0,
    message: failures.length ? `Senha fraca: ${failures.join(", ")}.` : null,
  };
}
